<script setup>
const route = useRoute();
const { $localApi } = useNuxtApp();
const userStore = useUserStore();

const {
  data,
  pending,
  error: videoError,
} = await $localApi.get(`/content/${route.params.id}/details`, {
  key: `content|detail|${route.params.id}`,
  transform: (data) => {
    return data.content;
  },
});

const { data: userRelatedData } = $localApi.get(`/content/${route.params.id}/details`, {
  key: `content|detail|${route.params.id}|${userStore.user?.id}|like`,
  transform: (data) => {
    return { liked: data.content.likedByUser, ...data.content };
  },
  server: false,
});

watch(
  data,
  () => {
    if (videoError.value) {
      throw createError({
        statusCode: 404,
        statusMessage: 'Page Not Found',
        fatal: true,
      });
    }

    if (data.value?.images) {
      useSeoMeta(
        {
          ogImage: data.value.images.detailImage,
          twitterImage: data.value.images.detailImage,
          title: data.value.title,
          twitterTitle: data.value.title,
          ogTitle: data.value.title,
        },
        {
          tagPriority: 'critical',
        },
      );

      useSchemaOrg([
        defineWebPage({
          mainEntity: useVideoSchema([data.value])[0],
        }),
      ]);
    }
  },
  { immediate: true },
);
</script>

<template>
  <div>
    <MoleculeLayoutDetailPage
      v-if="!pending && data"
      :data="data"
      :liked="userRelatedData?.liked"
      :watch="userRelatedData?.watch"
    />
    <MoleculeLayoutDetailSkeleton v-else />

    <PlayerComponentsRecommendedSliders class="px-2" />
  </div>
</template>
